import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { menuList_template } from "../components/templates/menuList_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {websiteMenuList_template} from "../components/templates/websiteMenuList_template";


declare var ko: any;
declare var page: any;

export class menu_list extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected menuList: menuList_template;  
    protected imageXHRHdl: XMLHttpRequestHandler;
    protected _isLeavePageWarningNeeded: boolean = true;
    

    protected getModuleName(){
        return "menu_list";
    }

    buildContent() : Array<Element>{

        this.menuList = new menuList_template( "menuList", this.viewModel, this );
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Menu List");

        return [ this.menuList.build()];
    }

    public fillPage() : void{
        
        this.getFormData();        
        //this.initializeCkEditors();
    }

    // obtain the dynamic data required to fill the formulary
    protected getFormData(){

        this.loadingIn(this.menuList.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idMenu = this.getVnAppZone().app.params.id;

        let usrReq_url: string = '/api/brand/' + idBrand + "/menu/get/"+ idMenu+"/";
        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push([
            "data", JSON.stringify({
                orderBy: "idParent",
                orderByDirection: 'ASC'
            })
        ]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }

    // use the form data to fill the form
    protected onGetFormDataReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                //this.initializeCkEditors();
                let data = responseParsed[0].data;

                obj.menuList.setMenuItems(data,parseInt(responseParsed.maxId),responseParsed.menuStyle);
                obj.menuList.setPermissions(responseParsed.permissions);
                obj.loadingOut(obj.menuList.builtTemplate);

            })

        }
    }

    protected save() {

        this.loadingIn(this.menuList.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idMenu = this.getVnAppZone().getApp().params.id;

        let formReq_url: string = '/api/brand/' + idBrand + "/menu/save/";

        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.viewModel));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        formReq_params.push(["menu",ko.toJSON({idMenu : idMenu})]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    // let responseParsed = JSON.parse(req.request.response);
                    // console.log(responseParsed)

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Menu saved successfully !");
                    page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand+ '/config/menu/');
                    //Remove all previous deleted items (if there are)
                    obj.viewModel.menuList.itemsToDelete([]);
                });
                obj.loadingOut(obj.menuList.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    public cancelForm() {
        this.cancel();
        page.redirect(this.getVnAppZone().app.getLastRoute());
    }

    protected cancel() {
        //this.getFormData();

        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Menu changes cancelled!");
        this.backAction();

    }

    protected backAction(){
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect("/brand/"+idBrand+"/config/menu/");

    }

    public setIsImageOptimized(val) {}

}



// WEBPACK FOOTER //
// ./js/modules/menu_list.ts